/* Breezary mobile filters — lift original Halo sidebar above custom mobile header.
 * Halo opens/closes its original element. We MOVE that element only after the
 * toolbar's opening click, then restore it after closing. Native Shopify
 * filtering links remain unchanged.
 */
(function(){
  'use strict';
  if(window.__bz5MobileLayerInstalled)return;
  window.__bz5MobileLayerInstalled=true;
  var sidebar=null, marker=null, mask=null, oldTitle=null, titleNode=null;
  var small=function(){return window.matchMedia('(max-width:1024px)').matches};
  function findSidebar(){
    if(sidebar&&sidebar.isConnected)return sidebar;
    var node=document.getElementById('halo-sidebar');
    return node&&node.querySelector('#main-collection-filters.bz5sf')?node:null;
  }
  function restore(){
    if(!sidebar)return;
    sidebar.classList.remove('bz5-mobile-layer');
    if(titleNode&&oldTitle!==null){titleNode.textContent=oldTitle;titleNode=null;oldTitle=null}
    if(marker&&marker.parentNode&&sidebar.parentNode!==marker.parentNode){
      marker.parentNode.insertBefore(sidebar,marker.nextSibling);
    }
    if(mask){mask.remove();mask=null}
    if(marker){marker.remove();marker=null}
  }
  function openLayer(){
    if(!small())return;
    var node=findSidebar();
    if(!node)return;
    if(sidebar===node&&node.classList.contains('bz5-mobile-layer'))return;
    sidebar=node;
    if(!marker){
      marker=document.createComment('Original Breezary collection sidebar location');
      node.parentNode.insertBefore(marker,node);
    }
    if(node.parentNode!==document.body)document.body.appendChild(node);
    node.classList.add('bz5-mobile-layer');
    titleNode=node.querySelector('.halo-sidebar-header .title');
    if(titleNode){oldTitle=titleNode.textContent;titleNode.textContent='Filters'}
    if(!mask){
      mask=document.createElement('button');
      mask.type='button';
      mask.className='bz5-mobile-filter-mask';
      mask.setAttribute('aria-label','Close filters');
      mask.addEventListener('click',function(){
        var close=sidebar&&sidebar.querySelector('[data-close-sidebar]');
        if(close)close.click();
        else restore();
      });
    }
    if(mask.parentNode!==document.body)document.body.appendChild(mask);
  }
  document.addEventListener('click',function(event){
    var trigger=event.target.closest('[data-sidebar]');
    if(trigger&&trigger.closest('.toolbar')&&small()){
      window.requestAnimationFrame(openLayer);
      return;
    }
    var close=event.target.closest('[data-close-sidebar]');
    if(close&&sidebar&&sidebar.contains(close)){
      window.requestAnimationFrame(restore);
      return;
    }
    if(mask&&event.target.closest('.background-overlay')){
      window.requestAnimationFrame(restore);
    }
  },true);
  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'&&sidebar&&sidebar.classList.contains('bz5-mobile-layer')){
      var close=sidebar.querySelector('[data-close-sidebar]');
      if(close)close.click();
      else restore();
    }
  },true);
  window.addEventListener('resize',function(){if(!small())restore()},{passive:true});
  document.addEventListener('shopify:section:unload',function(event){
    if(marker&&event.target.contains(marker)){
      if(sidebar){sidebar.classList.remove('bz5-mobile-layer');sidebar.remove()}
      if(mask){mask.remove();mask=null}
      if(marker){marker.remove();marker=null}
      sidebar=null;
    }
  });
})();